module.exports = __webpack_public_path__ + "img/LV1.182a8b11.svg";